module.exports = {"HN_BASE_API":"https://api.hnpwa.com/v0"}


//////////////////
// WEBPACK FOOTER
// ./src/Configs/Apis.json
// module id = 80
// module chunks = 0